import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import { parseCustomTime } from "../../../helpers/utils";
import useToken from "../../../helpers/useToken";
import useTimeZone from "../../../helpers/useTimeZone";
import PaginationCustom from "../../PaginationCustom/PaginationCustom";
import TMHLoader from "../../TMHLoader/TMHLoader";

export default function ApprovalTable({ notify, trigger, setTrigger }) {
  const { token } = useToken();
  const { timeZone } = useTimeZone();
  const [isLoading, setIsLoading] = useState(false);
  const [pager, setPager] = useState({
    size: 10,
    offset: 0,
  });

  const [totalPendingUsers, setTotalPendingUsers] = React.useState(0);
  const [pendingUsers, setPendingUsers] = React.useState();

  useEffect(() => {
    const initData = () => {
      console.log("ApprovalTable: update data");
      setIsLoading(true);
      var myHeaders = new Headers();
      myHeaders.append("Cache-Control", "no-cache");
      myHeaders.append("Access-Token", token);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      var params = new URLSearchParams({
        page_size: pager.size,
        offset: pager.offset,
      });

      fetch(
        process.env.REACT_APP_BASE_URL + "rewards/pending_users?" + params,
        requestOptions
      )
        .then((response) => {
          return new Promise((resolve) =>
            response.json().then((json) =>
              resolve({
                status: response.status,
                ok: response.ok,
                json,
              })
            )
          );
        })
        .then((result) => {
          var json = result.json;
          if (result.ok) {
            setPendingUsers(json.data);
            setTotalPendingUsers(json.page_dto.total);
            setIsLoading(false);
          } else {
            console.log(result.json.message);
            setIsLoading(false);
          }
        });
    };

    initData();
  }, [pager, token, trigger]);

  const rewardAction = (reward_id, mode) => {
    console.log("ApprovalTable:", mode);
    setIsLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cache-Control", "no-cache");
    myHeaders.append("Access-Token", token);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        reward_id: reward_id,
      }),
    };

    fetch(process.env.REACT_APP_BASE_URL + "rewards/" + mode, requestOptions)
      .then((response) => {
        return new Promise((resolve) =>
          response.json().then((json) =>
            resolve({
              status: response.status,
              ok: response.ok,
              json,
            })
          )
        );
      })
      .then((result) => {
        var json = result.json;
        if (result.ok) {
          notify("tl", json.message, "success");
          setTrigger(!trigger);
          setIsLoading(false);
        } else {
          notify("tl", json.message, "danger");
          setIsLoading(false);
        }
      });
  };

  const denialEmailAction = (user_id, denial_email_count) => {
    console.log("denialEmailAction");

    setIsLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Cache-Control", "no-cache");
    myHeaders.append("Access-Token", token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    fetch(
      process.env.REACT_APP_BASE_URL +
        "rewards/denial_email/" +
        String(user_id),
      requestOptions
    )
      .then((response) => {
        return new Promise((resolve) =>
          response.json().then((json) =>
            resolve({
              status: response.status,
              ok: response.ok,
              json,
            })
          )
        );
      })
      .then((result) => {
        var json = result.json;
        if (result.ok) {
          notify("tl", json.message, "success");
          setIsLoading(false);
          setTrigger(!trigger);
        } else {
          notify("tl", json.message, "danger");
          setIsLoading(false);
        }
      });
  };

  const approveAllCode = () => {
    if (
      !window.confirm("Do you want to approve all codes with location in US?")
    )
      return;
    console.log("approveAllCode");

    setIsLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Cache-Control", "no-cache");
    myHeaders.append("Access-Token", token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    fetch(
      process.env.REACT_APP_BASE_URL + "rewards/approve_all_code",
      requestOptions
    )
      .then((response) => {
        return new Promise((resolve) =>
          response.json().then((json) =>
            resolve({
              status: response.status,
              ok: response.ok,
              json,
            })
          )
        );
      })
      .then((result) => {
        var json = result.json;
        if (result.ok) {
          notify("tl", json.message, "success");
          setIsLoading(false);
          setTrigger(!trigger);
        } else {
          notify("tl", json.message, "danger");
          setIsLoading(false);
        }
      });
  };

  const denyAllNonUSCode = () => {
    if (!window.confirm("Do you want to deny all non-US codes?")) return;
    console.log("denyAllNonUSCode");

    setIsLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Cache-Control", "no-cache");
    myHeaders.append("Access-Token", token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    fetch(
      process.env.REACT_APP_BASE_URL + "rewards/deny_non_us_code",
      requestOptions
    )
      .then((response) => {
        return new Promise((resolve) =>
          response.json().then((json) =>
            resolve({
              status: response.status,
              ok: response.ok,
              json,
            })
          )
        );
      })
      .then((result) => {
        var json = result.json;
        if (result.ok) {
          notify("tl", json.message, "success");
          setIsLoading(false);
          setTrigger(!trigger);
        } else {
          notify("tl", json.message, "danger");
          setIsLoading(false);
        }
      });
  };

  return (
    <TMHLoader active={isLoading}>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <CardTitle tag="h2">Approval ({totalPendingUsers})</CardTitle>
              <Button onClick={approveAllCode} color="success">
                Approve All Code
              </Button>
              <Button onClick={denyAllNonUSCode} color="warning">
                Deny All non-US Code
              </Button>
            </CardHeader>
            <CardBody>
              <Row>
                <Col md="4" className="pt-2">
                  <CardTitle tag="h5">
                    Shows{" "}
                    <select
                      value={pager?.size}
                      onChange={(e) =>
                        setPager({
                          ...pager,
                          size: e.target.value,
                          offset: 0,
                        })
                      }
                    >
                      <option>10</option>
                      <option>25</option>
                      <option>50</option>
                      <option>100</option>
                    </select>{" "}
                    entries
                  </CardTitle>
                </Col>
              </Row>
              <Table striped className="tablesorter">
                <thead className="text-primary">
                  <tr>
                    <th>Partner </th>
                    <th>Name </th>
                    <th>Request Date</th>
                    <th>Method</th>
                    <th>Email</th>
                    <th>AdvertisingId</th>
                    <th className="text-center">Claimed</th>
                    <th>Pin</th>
                    <th>Progress</th>
                    <th>Country</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {pendingUsers?.map((rewardData) => {
                    return (
                      <tr key={rewardData.id}>
                        <td>{rewardData.partner_name}</td>
                        <td>
                          {rewardData.first_name} {rewardData.last_name}
                        </td>
                        <td>
                          {parseCustomTime(rewardData.added_at, timeZone)}
                        </td>
                        <td>{rewardData.signup_method}</td>
                        <td>{rewardData.email}</td>
                        <td>{rewardData.advertising_id}</td>
                        <td className="text-center">{rewardData.claimed}</td>
                        <td>{rewardData.pin}</td>
                        <td>{rewardData.progress}</td>
                        <td>{rewardData.country_code}</td>
                        <td className="text-center">
                          <Button
                            onClick={() => {
                              rewardAction(rewardData.id, "cancel_reward");
                            }}
                            className="btn-icon btn-simple"
                            color="danger"
                            size="sm"
                          >
                            <i className="fa fa-times" />
                          </Button>
                          {` `}
                          <Button
                            onClick={() => {
                              rewardAction(rewardData.id, "process_reward");
                            }}
                            className="btn-icon btn-simple"
                            color="success"
                            size="sm"
                          >
                            <i className="fa-solid fa-check"></i>
                          </Button>
                          {` `}
                          <Button
                            disabled={rewardData.country_code === "US"}
                            onClick={() => {
                              denialEmailAction(
                                rewardData.user_id,
                                rewardData.denial_email_count
                              );
                            }}
                            className="btn-icon btn-simple"
                            color="warning"
                            size="sm"
                          >
                            <i className="fa-solid fa-envelope"></i>
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationCustom
                pager={pager}
                setPager={setPager}
                total={totalPendingUsers}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </TMHLoader>
  );
}
